import * as types from "./types";

export const tutorial = {
  namespaced: true,

  state: {
    slide: 1
  },
  getters: {
    isTutorialToolUI: (state)=> {
      return state.slide == 3;
    }
  },
  mutations: {
    setSlide(state, slide) {
      state.slide = slide;
    }
  },
  actions: {
    [types.SET_SLIDE]({ commit }, slide) {
      commit("setSlide", slide);
    }
  }
};
